import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const addressApi = createAsyncThunk("address", async () => {
  const response = await axiosInstance.get("/address");
  return response.data;
});

const addressSlice = createSlice({
  name: "address",
  initialState: {
    address: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addressApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addressApi.fulfilled, (state, action) => {
        state.address = action.payload;
        state.loading = false;
      })
      .addCase(addressApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default addressSlice.reducer;
